// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
import AudioPlayerController from "./audio_player_controller"
import ButtonController from "./button_controller"
import CountdownTimerController from "./countdown_timer_controller"
import DateFieldController from "./date_field_controller"
import DismissController from "./dismiss_controller"
import DropdownController from "./dropdown_controller"
import ModalController from "./modal_controller"
import NestedFormController from "./nested_form_controller"
import NotificationsController from "./notifications_controller"
import RadioButtonSelectController from "./radio_button_select_controller"
import TabsController from "./tabs_controller"
import ToggleCheckboxController from "./toggle_checkbox_controller"
import TooltipController from "./tooltip_controller"
import ValidationController from "./validation_controller"

// Register all controllers
application.register("accordion", AccordionController)
application.register("audio-player", AudioPlayerController)
application.register("button", ButtonController)
application.register("countdown-timer", CountdownTimerController)
application.register("date-field", DateFieldController)
application.register("dismiss", DismissController)
application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("nested-form", NestedFormController)
application.register("notifications", NotificationsController)
application.register("radio-button-select", RadioButtonSelectController)
application.register("tabs", TabsController)
application.register("toggle-checkbox", ToggleCheckboxController)
application.register("tooltip", TooltipController)
application.register("validation", ValidationController)